import { render } from "./BottomMenu.vue?vue&type=template&id=e6427876"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"

import "./BottomMenu.vue?vue&type=style&index=0&id=e6427876&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__